import type { MenuDataItem } from '@ant-design/pro-components';
import { isMenuPathAllowed } from './permissionRegistry';
import type { ResolvedLayout } from './types';

/**
 * Оставить в меню только то, что открыто правами. Раздел остаётся, если внутри
 * уцелела хотя бы одна страница.
 */
export function filterMenuByPermissions(
  items: MenuDataItem[] | undefined,
  layout: ResolvedLayout,
): MenuDataItem[] {
  if (!items) return [];
  if (layout.menu === '*') return items;

  return items.reduce<MenuDataItem[]>((acc, item) => {
    const children = item.children ?? item.routes;
    if (children?.length) {
      const filtered = filterMenuByPermissions(children, layout);
      if (filtered.length) {
        const next: MenuDataItem = { ...item, children: filtered };
        // routes дублирует children — иначе рядом останется нефильтрованная копия.
        delete next.routes;
        acc.push(next);
      }
      return acc;
    }
    if (isMenuPathAllowed(layout, item.path)) {
      acc.push(item);
    }
    return acc;
  }, []);
}
